class NidInquiryStatusType {
  All() {
    return 0;
  }
  ReadyForInquiry() {
    return 1;
  }
  InProgress() {
    return 2;
  }
  Accepted() {
    return 3;
  }
  Rejected() {
    return 4;
  }
}
export default new NidInquiryStatusType();
